// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.clearcals.com',
  publicRecipesUrl: 'https://dev.api.clearcals.com/api/recipes/pub/',
  expertAppUrl: 'https://dev.expert.clearcals.com',
  appBaseUrl: 'https://dev.clearcals.com',
  url: '3mugyz-vn.myshopify.com/api/2025-01/graphql.json',
  shopifyaccesstoken: '59f621e72045e47ca3efc6572b09679d',
  hintPremiumVariantId: "gid://shopify/ProductVariant/42335031951429",
  razorpayKey: "rzp_live_62zIA3oxfx7pnH",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
